import ReferenceCheckContent from './ReferenceCheckContent';

export default ReferenceCheckContent;
